export enum TgvSubprodukt {
  TKV_V2 = 'TKV_V2',
  THH_HUND = 'THH_HUND',
  THH_PFERD = 'THH_PFERD',
}
